


import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonLargeList = () => {
    // Get theme from localStorage (default to 'light' if not set)
    const theme = localStorage.getItem("theme") || "light";

    // Define colors for light and dark themes
    const skeletonColors = theme === "dark"
        ? { baseColor: "#23272F", highlightColor: "#3A3F4B" }
        : { baseColor: "#CECECE", highlightColor: "#E8E8E8" };

    return (
        <Fragment>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                <div className="grid grid-cols-12 p-2 py-2 mt-1 w-full h-full" key={item}>
                    <div className="col-span-2 flex justify-start items-center">
                        <Skeleton {...skeletonColors}
                            height={40}
                            width={40}
                            circle={true}
                        />
                    </div>
                    <div className="col-span-4">
                        <Skeleton {...skeletonColors}
                            height={15}
                            width={100}
                        />
                        <Skeleton {...skeletonColors}
                            height={15}
                            width={150}
                        />
                    </div>
                    <div className="col-span-6 flex justify-end  gap-2 items-center">
                        <Skeleton {...skeletonColors}
                            height={30}
                            width={10}
                        />

                    </div>

                    <div className="col-span-11 flex justify-start w-full  gap-2 items-center">
                        <div className="w-full h-[40vw] md:h-[10vw]">
                            <Skeleton
                                {...skeletonColors}
                                width="100%"
                                height="100%"
                                style={{ borderRadius: "0.5rem" }}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </Fragment>
    )
}

export default SkeletonLargeList